export default __webpack_public_path__ + "static/media/messanger.22f02362.png";